var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FabricDropdown',{attrs:{"disabled":_vm.disabled || !_vm.finishedLoading,"right":"","toggle-class":"btn-dropdown"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('span',{class:[
        'status-item',
        'text-capitalize',
        _vm.resolveStatusClass(_vm.status && _vm.status.key ? _vm.status.key.toLowerCase() : ''),
      ]},[_vm._v(_vm._s(_vm.status.name))])]},proxy:true}])},_vm._l((_vm.changeableStatuses),function(item){return _c('FabricDropdownElement',{key:item.key,staticClass:"item",attrs:{"type":"link","element-classes":"tw-no-underline","value":item.key},on:{"click":function($event){return _vm.tryToChangeStatus(item)}}},[_c('span',{class:[
        'status-item',
        _vm.resolveStatusClass(item.key.toLowerCase()),
      ]},[_vm._v(_vm._s(item.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }